// Generated by scripts/build-gate-form-runtime.js. Do not edit manually.
export const GATE_FORM_RUNTIME_SCRIPT_SRC = "/vendor/form-runtime-c0e01f50c171.js";
export const GATE_FORM_RUNTIME_STYLE_HREF = "/vendor/form-runtime-2ee9476b7b93.css";
export const GATE_FORM_RUNTIME_COMPONENT_NAMES = [
    "prm-form",
    "prm-step",
    "prm-section",
    "prm-row",
    "prm-submit",
    "prm-form-summary",
    "prm-text-field",
    "prm-textarea-field",
    "prm-email-field",
    "prm-url-field",
    "prm-password-field",
    "prm-number-field",
    "prm-decimal-field",
    "prm-currency-field",
    "prm-boolean-field",
    "prm-date-field",
    "prm-datetime-field",
    "prm-time-field",
    "prm-choice-field",
    "prm-choice-field-item",
    "prm-reference-field",
    "prm-richtext-field",
    "prm-attachment-field",
    "prm-color-field"
] as const;
